import script from "./SuggestModal.vue?vue&type=script&lang=ts&setup=true"
export * from "./SuggestModal.vue?vue&type=script&lang=ts&setup=true"

import "./SuggestModal.vue?vue&type=style&index=0&id=6516fed1&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-6516fed1"]])

export default __exports__